(function () {
  var loadPromise;

  function getAssetUrls() {
    var el = document.getElementById('flickity-loader-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  window.loadFlickity = function loadFlickity() {
    if (typeof window.Flickity !== 'undefined') {
      return Promise.resolve(window.Flickity);
    }

    if (loadPromise) return loadPromise;

    var urls = getAssetUrls();
    if (!urls) {
      return Promise.reject(new Error('Flickity loader config missing'));
    }

    loadPromise = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = urls.css;
      document.head.appendChild(link);

      var script = document.createElement('script');
      script.src = urls.js;
      script.defer = true;
      script.onload = function () {
        resolve(window.Flickity);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return loadPromise;
  };
})();
